import { Route, Switch, useRouteMatch } from "react-router-dom";

import Container from "@components/container/container";
import Heading from "@components/heading/heading";
import useDocumentTitle from "@components/use-document-title/use-document-title";

import TemplateCategory from "./components/category";
import TemplateEdit from "./components/edit";
import TemplateList from "./components/list";
import TemplateView from "./components/view";

const Templates = () => {
  useDocumentTitle("Templates");
  const { path } = useRouteMatch();

  return (
    <Container ariaLabel="Templates" maxWidth="lg" padding="settings">
      <div className="mb-6">
        <Heading small title="Meeting Templates" />
      </div>
      <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
        <Switch>
          <Route exact path={[`${path}`, `${path}/group/:groupId`]}>
            <TemplateList />
          </Route>
          <Route
            exact
            path={[`${path}/category/new`, `${path}/category/:categoryId`]}
          >
            <TemplateCategory />
          </Route>
          <Route
            exact
            path={[
              `${path}/new`,
              `${path}/new/:duplicateId`,
              `${path}/:templateId(\\d+)/edit`,
              `${path}/:templateId(\\d+)/duplicate`,
            ]}
          >
            <TemplateEdit />
          </Route>
          <Route exact path={`${path}/:templateId(\\d+)`}>
            <TemplateView />
          </Route>
        </Switch>
      </div>
    </Container>
  );
};

export default Templates;
